<template>
  <footer class="dh-site-footer">
    <template v-if="backLink">
      <RouterLink to="/" class="dh-site-footer-link">
        <i class="fa-solid fa-arrow-left" />
        Retour à l'accueil
      </RouterLink>
      <span class="dh-site-footer-sep">·</span>
    </template>
    <span>© {{ new Date().getFullYear() }} DartsHub · Tous droits réservés.</span>
    <span class="dh-site-footer-sep">·</span>
    <RouterLink to="/mentions-legales" class="dh-site-footer-link">Mentions légales</RouterLink>
    <span class="dh-site-footer-sep">·</span>
    <RouterLink to="/politique-confidentialite" class="dh-site-footer-link">Politique de confidentialité</RouterLink>
    <span class="dh-site-footer-sep">·</span>
    <RouterLink to="/contact" class="dh-site-footer-link">Contact</RouterLink>
    <template v-if="!authStore.isAuthenticated">
      <span class="dh-site-footer-sep">·</span>
      <RouterLink to="/login" class="dh-site-footer-link">Connexion</RouterLink>
    </template>
    <span class="dh-site-footer-sep">·</span>
    <a class="dh-site-footer-link" href="https://www.facebook.com/dartshub.fr" target="_blank" rel="noopener"
      aria-label="Facebook DartsHub"><i class="fa-brands fa-facebook-f"></i></a>
    <span class="dh-site-footer-sep">·</span>
    <span>Développé par <a class="dh-site-footer-link" href="https://www.elpulpo.xyz" target="_blank"
        rel="noopener">El Pulpo</a> 🎯</span>
  </footer>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/useAuthStore';

defineProps<{ backLink?: boolean }>();

const authStore = useAuthStore();
</script>

<style scoped>
.dh-site-footer {
  background: var(--primary);
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  padding: 20px 24px;
  font-family: 'Poppins', 'Segoe UI', sans-serif;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
}

.dh-site-footer-sep {
  margin: 0 4px;
}

.dh-site-footer-link {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.dh-site-footer-link:hover {
  color: #ffffff;
  text-decoration: underline;
}
</style>
